import React, { useEffect, useState } from "react";
import LoaderComponent from "../loader-component/LoaderComponent";
import { useRequestCallback } from "./RequestCallbackContext";
import { Options } from "../ai-assist-refactored/quick-actions/quickActions.component";
import TypingEffect from "../ai-assist-refactored/utils/typing-effect/TypingEffect";
import { useTranslation } from "@me8eon/translation";
import { decodeEntities } from "../../util/strings";

const RequestCallbackResult: React.FC<{ data: any }> = ({ data }) => {
    const { getRequestCallback } = useRequestCallback();
    const [isLoading, setIsLoading] = useState(true);
    const t = useTranslation();
    const contextValues = getRequestCallback(data.requestCallbackSessionId);
    const successMsg = contextValues?.channel === "Phone" ? t("chatBot.quickActions.state.requestCallbackInQueuePhone").replace("<phone>", contextValues?.phone) : t("chatBot.quickActions.state.requestCallbackInQueueTeams");

    useEffect(() => {
        if (contextValues?.status !== "") {
            setIsLoading(false);
        }
    }, [contextValues?.status]);

    return (
        <>
            { isLoading && <LoaderComponent isLoading isLinear /> }
            { contextValues?.status === "success" && <TypingEffect className="bot-text" text={decodeEntities(`${successMsg}`)} speed={1} /> }
            { contextValues?.status === "failed" && <><TypingEffect className="bot-text" text={t("chatBot.quickActions.state.requestCallbackFailed")} speed={1} /><Options data={data} isButton={true}/></> }
        </>
    );
};

export default RequestCallbackResult;
